<dx-popup
  dragEnabled="true"
  resizeEnabled="true"
  [visible]="appGlobals.$showLogs | async"
  i18n-title="@@LOGS"
  title="LOGS"
  (onHiding)="handleOnHiding()"
  (onShowing)="doSearch($event, 'on-showing')"
  resizeEnabled="true"
  minHeight="400px"
  minWidth="600px"
  dragEnabled="true"
>
  <div
    (disablePopUpWindow)="setPopUpVisibilityFromChild($event)"
    id="gridContainerId"
  >
    <div *ngIf="!dxGridVisible">
      <h3 [innerHTML]="logFeedbackResponse"></h3>
    </div>
    <!-- <div style="position:relative;top:0px;">
            <dx-text-box [(value)]="searchTermLogs" mode="search" valueChangeEvent="keyup"
                (onValueChanged)="doSearch($event, 'on-typing')" i18n-placeholder="@@search ..."
                placeholder="Search ..." class="custom-search-panel-logs">
            </dx-text-box>
        </div> -->
    <div style="margin-top: 20px">
      <dx-data-grid
        [dataSource]="this.logRequest.logDetails"
        [columnAutoWidth]="true"
        class="gt-data-grid-style"
        [hoverStateEnabled]="true"
        [rowAlternationEnabled]="true"
        [wordWrapEnabled]="true"
        [height]="setLogGridHeight()"
        minHeight="100px"
        useNative="false"
        [allowColumnResizing]="true"
        columnResizingMode="widget"
        showScrollbar="always"
        [noDataText]="noData"
        [paging]="false"
        [scrolling]="true"
      >
        <dxo-search-panel
          [visible]="true"
          [width]="240"
          placeholder="Search..."
          i18n-placeholder="@@search..."
        ></dxo-search-panel>
        <dxo-scrolling mode="standard"></dxo-scrolling>
        <dxo-filter-row [visible]="false" height="40px"></dxo-filter-row>
        <dxi-column
          dataField="userName"
          sortIndex="0"
          i18n-caption="@@editedBy"
          caption="Edited By"
        ></dxi-column>
        <dxi-column
          dataField="dateChanged"
          dataType="date"
          i18n-caption="@@dateEdited"
          caption="Date Edited"
          format="dd.MM.yyyy"
          [allowSorting]="true"
        ></dxi-column>
        <dxi-column
          dataField="log"
          i18n-caption="@@log"
          caption="Log"
        ></dxi-column>
        <dxi-column
          dataField="previousValue"
          i18n-caption="@@previousValue"
          [width]="400"
          caption="Previous Value"
        ></dxi-column>
        <dxi-column
          dataField="newValue"
          i18n-caption="@@newValue"
          caption="New Value"
          [width]="400"
        ></dxi-column>
        <div *dxTemplate="let data of 'logTemplate'">
          <div *ngFor="let item of data.value">
            <p [innerHTML]="item"></p>
          </div>
        </div>
      </dx-data-grid>
    </div>
  </div>
</dx-popup>
